import { render, staticRenderFns } from "./sfsms.vue?vue&type=template&id=31ba5238&scoped=true&"
import script from "./sfsms.vue?vue&type=script&lang=js&"
export * from "./sfsms.vue?vue&type=script&lang=js&"
import style0 from "./sfsms.vue?vue&type=style&index=0&id=31ba5238&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ba5238",
  null
  
)

export default component.exports